module.exports = __webpack_public_path__ + "static/media/sub-banner-02-1.9825f353.jpg";